import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  promoWrapper: css`
    padding: ${spacing(2)};
    padding-block-start: ${spacing(3)};
  `,
  drawerSection: css`
    background: ${cssTheme.default.day.backgroundMinor};
    border-radius: ${spacing(3)};
    &:last-child {
      border-end-start-radius: 0;
      border-end-end-radius: 0;
    }
    & + & {
      margin-block-start: ${spacing(1)};
    }
  `,
  content: css`
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
}
